module.exports = __webpack_public_path__ + "img/canceled.68284abd.svg";